import { Component, OnInit } from "@angular/core";
import { INews, NewsOperationType } from "src/app/models/news.model";
import { Store } from "@ngrx/store";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AppState } from "src/app/store/app.state";
import { UserModel } from "src/app/models/user.model";
import { Roles } from "src/app/models/enums";
import { Subscription } from "rxjs";
import { ConfigService } from "src/app/config/config.service";
import { GetNewsAction } from "src/app/store/news/actions";
import { NewsEditModalComponent } from "../news/news/news-edit/news-edit-modal.component";

@Component({
  selector: "app-button-news",
  templateUrl: "./button-news.component.html",
  styleUrls: ["./button-news.component.scss"],
})
export class ButtonNewsComponent implements OnInit {
  private userSubscription: Subscription;

  url: String;
  news;
  writeNew;
  currentUser: UserModel;
  isLeagueRole = false;

  constructor(
    private configService: ConfigService,
    protected store: Store<AppState>,
    private readonly modalService: NgbModal,
  ) {}

  ngOnInit() {
    this.news = this.configService.get("features.news");
    this.writeNew = this.configService.get("features.news.writeNewText");

    this.userSubscription = this.store
      .select((state) => state.user.currentUser)
      .subscribe((user) => {
        if (user.role) {
          this.currentUser = user;
          this.isLeagueRole = user.role === Roles.League;
        }
      });
  }

  updateNewsList() {
    this.store.dispatch(new GetNewsAction(""));
  }

  btnClick(event: Event) {
    event.stopPropagation();
    const modalRef = this.modalService.open(NewsEditModalComponent, {
      centered: true,
      backdrop: "static",
      keyboard: false,
      modalDialogClass: "news-edit-modal-dialog",
    });
    const instance = modalRef.componentInstance as NewsEditModalComponent;
    instance.data = {
      newsItem: {
        application: "all",
        mailRecipients: "Broadcasters",
        targetCompetition: "1",
      } as INews,
      user: this.currentUser,
      type: NewsOperationType.Post,
    };
    const s = instance.finishNewsEdit.subscribe((res) => {
      if (res) {
        this.updateNewsList();
        s.unsubscribe();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }
}
